import React from "react";
import { useIntl } from "react-intl";
import css from "./MonthBand.module.css";
export var MonthBand = function (_a) {
    var month = _a.month, year = _a.year, received = _a.received, expected = _a.expected;
    var formatMessage = useIntl().formatMessage;
    var monthName = formatMessage({
        id: "ui-br-legaldeposits.periodicals.matrix.month.".concat(month),
    });
    return (React.createElement("div", { id: "month-".concat(year, "-").concat(month), className: css.band },
        React.createElement("span", null, "".concat(monthName, " ").concat(year)),
        React.createElement("span", { className: css.stat }, "".concat(received, " / ").concat(expected))));
};
